import { PaymentRequestSaveUseCase } from '../../../application';

export default class PaymentRequestSaveService {

    async execute(event) {
        const data = await PaymentRequestSaveUseCase(event);
        return data;
    }
}
